import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import duration from 'dayjs/plugin/duration'
import {Row} from "antd";
import {useDispatch} from "react-redux";
import {fetchVerificationCodeActionReset} from "../../../../../store/pages/profile/actions";

dayjs.extend(duration)

export const CountdownTimer = ({targetTime}:any) => {
  const dispatch = useDispatch();
  const [currentTime, setCurrentTime] = useState(dayjs())

  let timeBetween = dayjs.duration(targetTime.diff(currentTime))

  if(timeBetween.seconds() < 0){
    dispatch(fetchVerificationCodeActionReset())
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(dayjs())
    }, 1000)

    return () => clearInterval(interval)
  }, []);

  return(
    <Row>
      <p style={{marginBottom: 0}}>{timeBetween.minutes()}:</p>
      <p style={{marginBottom: 0}}>{timeBetween.seconds()}</p>
    </Row>
  )
}